<template>
  <div class="file-input-wrapper file-input-box">
    <div class="dropbox">
      <input
          type="file"
          class="input-file"
          @change="readFiles"
          :accept="this.field.fileTypes"
          :multiple="this.field.multipleFiles"
      >
      <p class="file-input-text">
        <span role="img" aria-label="upload" class="anticon anticon-upload">
          <svg class="icon-arrow-up-bracket" viewBox="64 64 896 896" focusable="false" data-icon="upload" width="1em"
               height="1em" fill="currentColor" aria-hidden="true">
            <path
                d="M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"></path>
          </svg>
        </span>
        <br><br>
        <span class="click-text">Click or drag file to this area to upload</span>
        <br><br>
        <span class="validation-text">Max upload size: 10MB</span>
      </p>
    </div>

    <div class="file-list" v-if="files.length > 0">
      <div class="file-list-header">
        <span>Selected Files</span>
        <button class="remove-all-btn" @click="removeAllFiles">Remove all</button>
      </div>
      <span v-for="(file, fileIndex) in files" :key="fileIndex" class="file-span">
        <span role="img" aria-label="paper-clip" class="anticon anticon-paper-clip">
          <svg viewBox="64 64 896 896" focusable="false" data-icon="paper-clip" width="1em" height="1em"
               fill="currentColor" aria-hidden="true">
            <path
                d="M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"></path>
          </svg>
        </span>
        <span class="file-name"> {{ file.name }}</span>
        <span class="trashcan-icon" @click="deleteFile(fileIndex)">
          <span role="img" aria-label="delete" tabindex="-1" class="anticon anticon-delete">
            <svg viewBox="64 64 896 896" focusable="false" data-icon="delete" width="1em" height="1em"
                 fill="currentColor" aria-hidden="true">
              <path
                  d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"></path>
            </svg>
          </span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    field: {},
    value: '',
  },
  data() {
    return {
      files: [],
    };
  },
  methods: {
    async readFiles(event) {
      const newFiles = event.target.files;
      const existingFiles = this.files;

      const filesToAdd = await Promise.all(
          Array.from(newFiles).map(async (file) => ({
            name: file.name,
            size: file.size,
            type: file.type,
            value: await this.toBase64(file),
            file: file
          }))
      );

      this.files = [
        ...existingFiles,
        ...filesToAdd.filter(newFile =>
            !existingFiles.some(existingFile => existingFile.name === newFile.name)
        )
      ];

      this.$emit('filled-out', this.files);
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      });
    },
    deleteFile(index) {
      this.files.splice(index, 1);
      this.$emit('filled-out', this.files);
    },
    removeAllFiles() {
      this.files = [];
      this.$emit('filled-out', this.files);
      // Clear the file input
      this.getFileInput().value = '';
    },
    getFileInput() {
      return document.getElementById(this.field.id).querySelector(".input-file");
    }
  }
};
</script>

<style scoped>
.file-input-box {
  width: 100%;
  height: 100%;
}

.file-input-wrapper {
  border: 0;
  padding: 0;
}

.dropbox {
  outline: 1.5px dashed #dddedf;
  border-radius: 5px;
  color: dimgray;
  padding: 10px;
  height: 170px;
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0;
  width: 100%;
  height: 170px;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 23px 0;
}

.icon-arrow-up-bracket {
  height: 27px;
  width: auto;
}

.click-text {
  font-weight: bold;
}

.validation-text {
  font-size: 15px;
}

.file-input-text {
  line-height: 18px;
}

.file-list {
  width: 100%;
  margin-top: 10px;
}

.file-span {
  display: flex;
  align-items: center;
  padding: 5px;
  transition: background-color 0.3s ease;
}

.file-span:hover {
  background-color: #f5f5f5;
}

.file-name {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trashcan-icon {
  cursor: pointer;
  opacity: 0.2;
  transition: opacity 0.3s ease;
}

.file-span:hover .trashcan-icon {
  opacity: 1;
}

.file-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.remove-all-btn {
  background-color: #f5f5f5;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  padding: 4px 15px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.remove-all-btn:hover {
  color: #40a9ff;
  border-color: #40a9ff;
}

.remove-all-btn:active {
  color: #096dd9;
  border-color: #096dd9;
}
</style>